import { getSystemSettings } from './SettingsRetriever';

const getDateFormat = (type) => {
    const config = getSystemSettings();
    if (type === "display" && config && config.app && config.app.display_dates) return config.app.display_dates
    if (!type && config && config.app && config.app.format_dates) return config.app.format_dates
    return "MM/DD/YYYY";
}

export default getDateFormat;